export default "__VITE_ASSET__dfe40553__"